// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"8bcef213","256":"0ebb6bf2","316":"44443a50","490":"40cbe4bd","693":"c712ec2b"}[chunkId] + ".chunk.js";
};